import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;

export function SupportLink({ testid, className = "" }) {
  return <a href={`mailto:${SUPPORT_EMAIL}`} data-testid={testid} className={`text-amber-300 hover:text-amber-200 underline-offset-4 hover:underline ${className}`}>{SUPPORT_EMAIL}</a>;
}

export function OrderHelp({ testid }) {
  return (
    <p data-testid={testid} className="flex items-center justify-center gap-2 text-xs text-slate-400">
      <Mail className="w-3.5 h-3.5" />Help with an order? Email <SupportLink testid={`${testid}-email`} />
    </p>
  );
}

export function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-wrap items-center justify-between gap-4 text-sm text-slate-400">
        <p><span className="font-display text-amber-100">Wolfpack Games</span> · Most Wolf Player</p>
        <div className="flex flex-wrap items-center gap-5">
          <Link to="/contact" data-testid="footer-contact-link" className="hover:text-white transition-colors">Support & collabs</Link>
          <SupportLink testid="footer-support-email" />
        </div>
      </div>
    </footer>
  );
}
